import { defineComponent as _defineComponent } from 'vue'
import { getThumbUrl } from '@/utils/imageUtils';


export default /*#__PURE__*/_defineComponent({
  __name: 'PageFileOption',
  props: {
    thumb: null,
    label: null
  },
  setup(__props: any) {



return { __sfc: true,getThumbUrl }
}

})